<template lang="pug">
b-modal#editDepositTier(
  ref="editDepositTier"
  :title="$t('ui.combine.edit_color')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
  )
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$t('ui.deposit_amount')").mb-1
      DebounceInput(
        size="sm"
        ref="deposit"
        required
        type="text"
        :dirty="$v.deposit.$dirty"
        :error="$v.deposit.$error"
        v-model.trim.lazy="$v.deposit.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.deposit" :name="$t('ui.deposit_amount')")
    b-form-group(:label="$t('ui.reward')").mb-1
      DebounceInput(
        size="sm"
        ref="reward"
        required
        type="text"
        :dirty="$v.reward.$dirty"
        :error="$v.reward.$error"
        v-model.trim.lazy="$v.reward.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.reward" :name="$t('ui.reward')")

  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-times" :text="$t('ui.close')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, decimal, minValue } from "vuelidate/lib/validators";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import config from "@/config";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    itemDt: {
      type: Object
    },
    operatorID: {
      type: String
    }
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      settingList: [],
      deposit: '',
      reward: '',
    };
  },
  validations: {
    deposit: {
      required,
      decimal,
      minValue(value) {
        return minValue(this.getMinDeposit())(value)
      },
    },
    reward: {
      required,
      decimal,
      minValue: minValue(0)
    },
  },
  methods: {
    getMinDeposit: function() {
      for(var i = 0; i < this.settingList.length; i++) {
        if(this.settingList[i].setting_key == 'min_deposit') {
          return this.settingList[i].setting_value;
        }
      }

      return 100
    },
    getOperatorSettingList: function() {
      let url = config.operatorSettingListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.settingList = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.triggerOpDepositTierEditUrl();

        var json = {
          auth_token: this.$store.getters.sessionToken,
          action_by: this.$store.getters.loginId,
          operator_id: this.operatorID,
          tier_id: this.itemDt.id,
          deposit: this.deposit,
          reward: this.reward
        };

        this.feedback.success = true;
        this.loading = true;

        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = (typeof response.data.status == "string") ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "combine.edit_deposit_tier", this.feedback.status);
                }
                this.$nextTick(() => {
                  this.$refs.editDepositTier.hide();
                });
              }
            } catch (error) {
              this.loading = false;
              if (error.status.toLowerCase() == "nochanges") {
                this.$emit("clicked");
                this.$nextTick(() => {
                  this.$refs.editDepositTier.hide();
                });
              } else {
                this.feedback.success = false;
                this.feedback.status = error.status;
                this.$helpers.handleFeedback(this.feedback.status);
              }
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = response.data.status;
            this.$helpers.handleFeedback(this.feedback.status);
          }
        );
      }
    },
    reset() {
      this.settingList = [];
      this.deposit = "";
      this.reward = "";
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown() {
      this.getOperatorSettingList();
      this.$v.$reset();
      this.deposit = this.itemDt.deposit;
      this.reward = this.itemDt.reward;
      this.$refs.deposit.$el.focus();
    }
  }
};
</script>
